export default "__VITE_ASSET__QmD7WXB1__"